<div id="nk-shortcuts" #shortcuts>
  <div
    class="shortcuts"
    style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%;"
  >
    <!-- Shortcut Icons (Left Column) -->
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
        flex-wrap: nowrap;
        overflow-x: auto;
        flex: 1;
      "
    >
      <div
        class="w20 h40 p4 shortcut-wrapper"
        style="flex: 0 0 auto; display: flex; align-items: center; justify-content: center;"
       *ngFor="let shortcutItem of shortcutItems; let first = first"
  [ngClass]="{ 'first-shortcut': first }"
      >
        <a
          mat-icon-button
          matTooltip="{{ shortcutItem.title }}"
          [routerLink]="shortcutItem.url"
          style="display: flex; align-items: center; justify-content: center;"
        >
          <mat-icon class="secondary-text shortcut_icon" *ngIf="shortcutItem.icon">
            {{ shortcutItem.icon }}
          </mat-icon>
          <span *ngIf="!shortcutItem.icon" class="h2 secondary-text text-bold">
            {{ shortcutItem.title.substr(0, 1).toUpperCase() }}
          </span>
        </a>
      </div>
    </div>

    <!-- Star Button (Right Column) -->
    <div style="flex: none;">
      <button
        mat-icon-button
        [matMenuTriggerFor]="addMenu"
        matTooltip="Click to add/remove shortcut"
        (menuOpened)="onMenuOpen()"
        [ngClass]="{ 'star-btn': shortcutItems.length === 0 }"
        style="background-color: inherit; border-radius: 0; box-shadow: none; border: none;"
      >
        <mat-icon class="amber-600-fg">star</mat-icon>
      </button>
    </div>
  </div>

  <!-- Mat Menu below (unchanged) -->
  <mat-menu #addMenu="matMenu" class="w240 ">
    <div style="display: flex; flex-direction: column;">
      <mat-form-field class="px16" (click)="$event.stopPropagation()" floatLabel="auto">
        <input
          #searchInput
          autocomplete="off"
          matInput
          placeholder="Search for an app or a page"
          (focus)="search(searchInput.value)"
          (input)="search(searchInput.value)"
        />
      </mat-form-field>
      <mat-divider></mat-divider>
      <mat-nav-list *ngIf="!searching" style="max-height: 312px; overflow: auto">
        <mat-list-item *ngFor="let shortcutItem of shortcutItems" (click)="toggleShortcut($event, shortcutItem)">
          <div style="width: 100%; display: flex; flex-direction: row; align-items: center;">
            <mat-icon mat-list-icon class="mr8 secondary-text " *ngIf="shortcutItem.icon">
              {{ shortcutItem.icon }}
            </mat-icon>
            <div
              class="h2 h32 w32 p4 mr8 secondary-text text-bold"
              style="display: flex; align-items: center; justify-content: center;"
              *ngIf="!shortcutItem.icon"
            >
              {{ shortcutItem.title.substr(0, 1).toUpperCase() }}
            </div>
            <div style="flex: 1;">{{ shortcutItem.title }}</div>
            <mat-icon class="ml8 amber-fg">star</mat-icon>
          </div>
        </mat-list-item>
        <mat-list-item *ngIf="shortcutItems.length === 0">
          <p><small>No shortcuts yet!</small></p>
        </mat-list-item>
      </mat-nav-list>
      <mat-nav-list *ngIf="searching" style="max-height: 312px; overflow: auto">
        <mat-list-item
          *ngFor="let navigationItem of filteredNavigationItems"
          (click)="toggleShortcut($event, navigationItem)"
        >
          <div style="width: 100%; display: flex; flex-direction: row; align-items: center;">
            <mat-icon mat-list-icon class="mr8 secondary-text " *ngIf="navigationItem.icon">
              {{ navigationItem.icon }}
            </mat-icon>
            <div
              class="h2 w32 h32 p4 mr8 secondary-text text-bold"
              style="display: flex; align-items: center; justify-content: center;"
              *ngIf="!navigationItem.icon"
            >
              {{ navigationItem.title.substr(0, 1).toUpperCase() }}
            </div>
            <div style="flex: 1;">{{ navigationItem.title }}</div>
            <mat-icon class="ml8 amber-fg" *ngIf="isInShortcuts(navigationItem)">star</mat-icon>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </mat-menu>
</div>
